import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import MenuListComponent from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import TextField from "@material-ui/core/TextField";
import { instance } from "Actions/AxiosInstance";
import TextArea from "Component/Material-ui/TextArea";
import get from "lodash/get";
import {
  List,
  TDTypeConsts,
} from "Module/Subscription/business-configration/commons";
// import DeleteIcon from "@material-ui/icons/cancel";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
import Select from "react-select";
import {
  ValidateAction,
  ValidateList,
  ValidateReqField,
  ValidateReqFields,
  ValidateSearchDropdown,
} from "Utils/Validation";

import { isSpecialChracterIncluded } from "Utils"

const REGEX_IP = /^(?:[0-9]{1,3}.){3}[0-9]{1,3}$/;

const longitudeStyle = {
  paddingBottom: 10,
};

class company_location extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Location: [],
      listdata: [],
      value: 2,
      flag: 0,
      MarkdownText: "",
      selectedRow: null,
      progress: 0,
      isSave: false,
      // isClicked: false,
      subscriptionid:
        this.props.SubscriptionInfo.SubscriptionData &&
        this.props.SubscriptionInfo.SubscriptionData.subscriptionid,
      // subscriptionid: 65,
      // officeaddressid: this.props.officedata.displayvalue,
      // addressid: this.props.officedata.addressid,
      checkedA: true,
      checkedB: true,
      fields: {
        locationname: "",
        addressline1: "",
        addressline2: "",
        pincode: "",
        officeaddressid: "",
        addressid: "",
        longitude: "",
        latitude: "",
        radius: "",
      },
      reqFields: {
        locationname: "",
        addressline1: "",
        pincode: "",
        // longitude: "",
        // latitude: "",
        // radius: ""
      },
      list: {
        addresstype: "",
        countryid: "",
        stateid: "",
        cityid: "",
        countrytimezoneid: "",
      },
      reqList: {
        addresstype: "",
        countryid: "",
        stateid: "",
        cityid: "",
        countrytimezoneid: "",
      },
      errors: {},
      helperText: {},
      country: [],
      selectedCountry: {
        displayvalue: null,
        displayname: "Select country",
      },
      stateprovince: [],
      selectedState: {
        displayname: "Select State",
        displayvalue: null,
      },
      cityzone: [],
      selectedCity: {
        displayname: "Select City",
        displayvalue: null,
      },
      timezones: [],
      networkTypeList: [],
      selectedNetworkType: {},
      selectedTimeZone: {
        displayname: "Select Time Zone",
        displayvalue: null,
      },
      ipList: [
        {
          ipaddressfrom: "",
          ipaddressto: "",
          isblocked: false,
          networktypeid: "",
          officeaddressid: undefined,
          officeaddressipid: 0,
        },
      ],
      headers: [
        {
          key: "locationname",
          name: "Location name",
          style: { textAlign: "left", width: "20%" },
          type: TDTypeConsts.OPTIONAL_HOLIDAY_NAME,
        },
        {
          key: "addresstype",
          name: "Address type",
          type: TDTypeConsts.OPTIONAL_HOLIDAY_NAME,
          style: { textAlign: "left" },
        },
        {
          key: "cityname",
          name: "City",
          type: TDTypeConsts.OPTIONAL_HOLIDAY_NAME,
          style: { textAlign: "left" },
        },
        {
          key: "pincode",
          name: "Postal Code",
          type: TDTypeConsts.OPTIONAL_HOLIDAY_NAME,
          style: { textAlign: "left" },
        },

        {
          key: "",
          name: "",
          type: TDTypeConsts.MORE_OPTIONS,
        },
      ],
    };
    this.GetForm = this.GetForm.bind(this);
    this.getCountry = this.getCountry.bind(this);
    this.getAddresstype = this.getAddresstype.bind(this);
    this.getTimezone = this.getTimezone.bind(this);
    this.GetNetworkType = this.GetNetworkType.bind(this);
    this.GetLocations = this.GetLocations.bind(this);
    this.clearAll = this.clearAll.bind(this);
    this.ipAddressUpdate = this.ipAddressUpdate.bind(this);
    // this.onContinue = this.onContinue.bind(this);
    this.handleClickWithAction = this.handleClickWithAction.bind(this);
    this.onMoreOptionClick = this.onMoreOptionClick.bind(this);
    this.getAllCompanyLocations = this.getAllCompanyLocations.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.DeleteLocation = this.DeleteLocation.bind(this);
    this.onEdit = this.onEdit.bind(this);
  }

  componentWillMount() {
    this.GetLocations();
    this.getCountry();
    this.getAddresstype();
    this.getTimezone();
    this.GetNetworkType();
    this.getAllCompanyLocations();
  }

  onMoreOptionClick(event, row) {
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
      selectedRow: row,
    });
  }

  isIpValid = () => {
    const { ipList } = this.state;
    let valid = true;
    if (ipList.length != 0) {
      ipList.forEach((item) => {
        if (item.ipaddressfrom || item.ipaddressto) {
          if (
            !REGEX_IP.test(get(item, "ipaddressfrom", "")) ||
            !REGEX_IP.test(get(item, "ipaddressto", ""))
          ) {
            valid = false;
          }
        }
      });
    }
    return valid;
  };

  onCancel = () => {
    this.props.enqueueSnackbar(` Are you sure, you would lost your progress?`, {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            this.props.history.push(`${this.props.match.path}`);
            this.props.closeSnackbar();
            this.clearAll();
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            this.props.closeSnackbar();
            this.clearAll();
          }}
        >
          No
        </Button>,
      ],
    });
  };

  isGeoLocationValid = () => {
    const lat = this.state.fields.latitude || "";
    const lng = this.state.fields.longitude || "";
    const latreg =
      "^(\\+|-)?(?:90(?:(?:\\.0{1,6})?)|(?:[0-9]|[1-8][0-9])(?:(?:\\.[0-9]{1,6})?))$";
    const lngreg =
      "^(\\+|-)?(?:180(?:(?:\\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\\.[0-9]{1,6})?))$";
    let valid = true;
    if (lat || lng) {
      if (!lat.match(latreg) || !lng.match(lngreg)) {
        valid = false;
      }
    }
    return valid;
  };

  isGeoRadiusValid = () => {
    if (this.state.fields.radius && this.state.fields.radius < 30) {
      return false;
    }
    return true;
  };

  Validate() {
    let formIsValid = true;
    if (!ValidateReqFields(this.state)) {
      this.props.enqueueSnackbar("Please fill all required fields", {
        variant: "error",
      });
      formIsValid = false;
    } else if (!ValidateList(this.state)) {
      this.props.enqueueSnackbar("Please enter valid input", {
        variant: "error",
      });
      formIsValid = false;
    } else if (!this.isIpValid()) {
      this.props.enqueueSnackbar("Invalid ip", { variant: "error" });
      formIsValid = false;
    } else if (!this.isGeoLocationValid()) {
      this.props.enqueueSnackbar("Invalid geo location", { variant: "error" });
      formIsValid = false;
    } else if (!this.isGeoRadiusValid()) {
      this.props.enqueueSnackbar("Invalid geo radius", { variant: "error" });
      formIsValid = false;
    } else if (!this.state.list.addresstype) {
      this.props.enqueueSnackbar("Please select address type", {
        variant: "error",
      });
      formIsValid = false;
    } else if (isSpecialChracterIncluded(this.state.fields.locationname)) {
      this.props.enqueueSnackbar("Special characters are not allowed in location name", {
        variant: "error",
      });
      formIsValid = false;
    }
    return formIsValid;
  }

  OnFormSubmit() {
    if (this.Validate()) {
      const getofficeaddressid = (data) => {
        if (get(data, "officeaddressip[0]", "")) {
          return get(data, "officeaddressip[0].ipaddressfrom", "") &&
            get(data, "officeaddressip[0].ipaddressto", "")
            ? data
            : null;
        }
        return null;
      };
      const data = {
        // subscriptionid: get(this.state, "subscriptionid", ""),
        subscriptionid: get(
          this.props,
          "SubscriptionInfo.SubscriptionData.subscriptionid",
          "",
        ),
        officeaddressid: this.state.fields.officeaddressid || null,
        addressid: this.state.fields.addressid
          ? this.state.fields.addressid
          : null,
        pincode: this.state.fields.pincode ? this.state.fields.pincode : null,
        addresstype: this.state.list.addresstype || null,
        addressline2: this.state.fields.addressline2
          ? this.state.fields.addressline2
          : null,
        locationname: this.state.fields.locationname || null,
        addressline1: this.state.fields.addressline1 || null,
        countryid: this.state.list.countryid || null,
        stateid: this.state.list.stateid || null,
        cityid: this.state.list.cityid || null,
        countrytimezoneid: this.state.list.countrytimezoneid || null,
        longitude: this.state.fields.longitude || null,
        radius: this.state.fields.radius || null,
        latitude: this.state.fields.latitude || null,
        officeaddressipdata: getofficeaddressid({
          officeaddressip: this.state.ipList,
        }),
        // stepcompleted: this.props.dashboard
        //   ? this.props.currentsubscription &&
        //     this.props.currentsubscription.stepcompleted
        //   : this.props.stepcompleted > this.props.step
        //   ? this.props.stepcompleted
        //   : this.props.step,
      };
      // if (this.props.dashboard) {
      //   this.props.enqueueSnackbar("Saved successfully", { variant: "success" });
      // }
      instance
        .post("subscription/companylocation", data)
        .then((result) => {
          this.setState({
            subscriptionid: get(
              this.props,
              "SubscriptionInfo.SubscriptionData.subscriptionid",
              "",
            ),
            officeaddressid: "",
            addressid: "",
            pincode: "",
            addresstype: "",
            addressline2: "",
            locationname: "",
            addressline1: "",
            countryid: "",
            stateid: "",
            cityid: "",
            countrytimezoneid: "",
            longitude: "",
            radius: "",
            latitude: "",
            ipList: [],
            isSave: true,
            officeaddressipdata: { officeaddressip: {} },
          });
          // if (this.props.dashboard) {
          //   this.props.enqueueSnackbar("Saved successfully", {
          //     variant: "success",
          //   });
          // }
          // if (!this.props.dashboard) {
          //   this.props.updateStep(4);
          // }
          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });
          this.GetForm();
          this.GetLocations();
          this.clearAll();
          this.props.history.push(`${this.props.match.path}`);
          this.getAllCompanyLocations();
          // this.props.checkReset();
          // this.props.TabChangeFun(0);
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  getAllCompanyLocations() {
    instance
      .post(`subscription/getcompanylocationlist`, {
        isactive: true,
        limit: 10,
        offset: 0,
      })
      .then((resp) => {
        this.setState({
          listdata: resp.data.result,
          data: true,
          backupList: resp.data.result,
          createmenu: false,
        });
      });
  }

  getAddresstype() {
    instance
      .get("superuser/getmastercode/OfficeAddressType")
      .then((result) => {
        const addressTypeList = [];
        addressTypeList.push(
          { displayname: "Select Address Type", displayvalue: "" },
          ...result.data.result,
        );
        if (this.state.list.addresstype) {
          const selectedAddressType = this.state.addressTypeList.find(
            (x) => x.displayvalue == this.state.list.addresstype,
          );
          this.setState({ selectedAddressType });
        }
        this.setState({ addressTypeList });
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  getCountry() {
    instance
      .get("superuser/allcountry")
      .then((result) => {
        const country = [];
        country.push(
          { displayname: "Select Country", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ country });
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  getState() {
    if (this.state.list.countryid) {
      const URL = `superuser/statebycountryid/${this.state.list.countryid}`;
      instance
        .get(URL)
        .then((result) => {
          const stateprovince = [];
          stateprovince.push(
            { displayname: "Select State", displayvalue: "" },
            ...result.data.result,
          );
          this.setState({
            stateprovince,
            selectedState: result.data.result.find(
              (x) => x.displayvalue == this.state.list.stateid,
            ),
          });
        })
        .catch((error) => {
          this.setState({ CommonError: error.message });
        });
    } else {
      let cityzone;
      const stateprovince = [
        {
          displayname: "Select State",
          displayvalue: "",
        },
      ];
      cityzone = [
        {
          displayname: "Select City",
          displayvalue: "",
        },
      ];
      this.setState({ stateprovince, cityzone });
    }
  }

  getCity() {
    if (this.state.list.stateid && this.state.list.countryid) {
      const URL = `superuser/citybystateid/${this.state.list.stateid}`;
      instance
        .get(URL)
        .then((result) => {
          const cityzone = [];
          cityzone.push(
            { displayname: "Select City", displayvalue: "" },
            ...result.data.result,
          );
          this.setState({
            cityzone,
            selectedCity: result.data.result.find(
              (x) => x.displayvalue == this.state.list.cityid,
            ),
          });
        })
        .catch((error) => {
          this.setState({ CommonError: error.message });
        });
    } else {
      let cityzone;
      cityzone = [
        {
          displayname: "Select City",
          displayvalue: "",
        },
      ];
      this.setState({ cityzone });
    }
  }

  getTimezone() {
    instance
      .get("superuser/alltimezone")
      .then((result) => {
        const timezones = [];
        timezones.push(
          { displayname: "Select Timezone", displayvalue: "" },
          ...result.data.result,
        );
        if (this.state.list.countrytimezoneid) {
          const selectedTimeZone = this.state.timezones.find(
            (x) => x.displayvalue == this.state.list.countrytimezoneid,
          );
          this.setState({ selectedTimeZone });
        }
        this.setState({ timezones });
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  GetNetworkType() {
    instance
      .get("superuser/getmastercode/NetworkType")
      .then((result) => {
        const networkTypeList = [];
        networkTypeList.push(
          { displayname: "Select IP Address Type", displayvalue: "" },
          ...result.data.result,
        );
        this.setState({ networkTypeList });
      })
      .catch((error) => {
        this.setState({ CommonError: error.message });
      });
  }

  SetHelperTextFlag(field, HtField, e) {
    const { helperText } = this.state;
    helperText[field] = true;
    this.setState({ helperText });
  }

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    fields[field] = e.target.value ? e.target.value : "";
    this.setState({ fields }, () => {
      ValidateAction(this.state, field, type);
    });
    if (field == "addressline2" || field == "pincode") {
    }
  }

  ValidateField(reqField, type, e) {
    if (
      reqField === "latitude" ||
      reqField === "longitude" ||
      reqField === "radius"
    ) {
    } else {
      const { reqFields } = this.state;
      reqFields[reqField] = e.target.value ? e.target.value : "";
      reqFields[reqField] = e.target.value;
      this.setState({ reqFields });
    }
    if (ValidateAction(this.state, reqField, type)) {
      if (
        reqField === "latitude" ||
        reqField === "longitude" ||
        reqField === "radius"
      ) {
      } else {
        ValidateReqField(this.state, reqField, type);
      }
    }
  }

  UpdateSelectedDropdownItem(name, HtField, selectedItem) {
    const { list } = this.state;
    const { reqList } = this.state;
    list[name] = selectedItem.displayvalue ? selectedItem.displayvalue : "";
    this.setState({ list });
    if (name === "countryid") {
      Object.assign(this.state.list, { stateid: "", cityid: "" });
      this.setState(
        {
          list,
          selectedState: "",
          selectedCity: "",
          selectedCountry: selectedItem,
        },
        () => {
          this.getState();
          this.getCity();
        },
      );
    }
    if (name === "stateid") {
      Object.assign(this.state.list, { cityid: "" });
      this.setState(
        { list, selectedState: selectedItem, selectedCity: "" },
        () => {
          this.getCity();
        },
      );
    }
    if (name === "cityid") {
      this.setState({ list, selectedCity: selectedItem });
    }

    if (name === "countrytimezoneid") {
      this.setState({ list, selectedTimeZone: selectedItem });
    }

    if (name === "addresstype") {
      this.setState({ list, selectedAddressType: selectedItem });
    }

    if (reqList[name] == "" || reqList[name]) {
      reqList[name] = selectedItem.displayvalue
        ? selectedItem.displayvalue
        : "";
      this.setState({ reqList }, () => {
        this.ValidateEachDropDown(name);
      });
    }
  }

  ipAddressUpdate(item, index, type, event) {
    const { ipList } = this.state;
    const { errors } = this.state;
    item[type] = event.target.value;
    ipList[index] = item;
    this.setState({ ipList });
  }

  UpdateSelectedIpAddressType(item, HtField, selectedItem) {
    const { ipList } = this.state;
    item.networktypeid = selectedItem.displayvalue;

    const index = this.state.ipList.findIndex(
      (x) => x.officeaddressipid == item.officeaddressipid,
    );
    ipList[index] = item;

    this.setState({ ipList });
  }

  ValidateEachDropDown(name) {
    ValidateSearchDropdown(this.state, name).then((result) => {
      this.setState({
        errors: result.errors,
      });
    });
  }

  GetLocations() {
    const URL = "subscription/allcompanylocation";
    const data = {
      subscriptionid: get(this.state, "subscriptionid", ""),
    };
    instance
      .post(URL, data)
      .then((result) => {
        const Location = [];
        Location.push(
          // {
          //   displayname: (
          //     <FormattedMessage
          //       id="LbAddnewofficelocation"
          //       defaultMessage="Add new office address"
          //     />
          //   ),
          //   displayvalue: "",
          // },
          ...result.data.result,
        );
        this.setState({ Location });

        // console.log(this.state.Location);
      })
      .catch((error) => {
        this.setState({
          CommonError: error.message,
        });
      });
  }

  GetForm(item) {
    // console.log(item);
    if (item && item.addressid && item.displayvalue) {
      const URL = `subscription/companylocation/${get(
        this.state,
        "subscriptionid",
        "",
      )}/${item.displayvalue}/${item.addressid}`;
      instance
        .get(URL)
        .then((result) => {
          const data = result.data.result;
          if (data) {
            const fields = {
              accountid: data && data.accountid && data.accountid,
              subscriptionid:
                data && data.subscriptionid && data.subscriptionid,
              officeaddressid:
                data && data.officeaddressid && data.officeaddressid,
              addressid: data && data.addressid && data.addressid,
              locationname: data && data.locationname && data.locationname,
              addressline1: data && data.addressline1 && data.addressline1,
              addressline2: data && data.addressline2 && data.addressline2,
              pincode: data && data.pincode && data.pincode,
              longitude: data && data.longitude && data.longitude,
              latitude: data && data.latitude && data.latitude,
              radius: data && data.radius && data.radius,
            };
            const reqFields = {
              locationname: data && data.locationname,
              addressline1: data && data.addressline1,
              pincode: data && data.pincode,
              // longitude: data && data.longitude,
              // latitude: data && data.latitude,
              // radius: data && data.radius
            };
            const list = {
              addresstype: data.addresstype,
              countryid: data.countryid,
              stateid: data.stateid,
              cityid: data.cityid,
              countrytimezoneid: data.countrytimezoneid,
            };
            const reqList = {
              addresstype: data.addresstype,
              countryid: data.countryid,
              stateid: data.stateid,
              cityid: data.cityid,
              countrytimezoneid: data.countrytimezoneid,
            };
            const ipList =
              result.data.result.ip.length > 0
                ? result.data.result.ip
                : this.state.ipList;
            const selectedAddressType = this.state.addressTypeList.find(
              (x) => x.displayvalue == list.addresstype,
            );
            let addressTypeName = "";
            for (const type of this.state.addressTypeList) {
              if (type.displayvalue == list.addresstype) {
                addressTypeName = type.displayname;
              }
            }
            const selectedTimeZone = this.state.timezones.find(
              (x) => x.displayvalue == list.countrytimezoneid,
            );
            const selectedCountry = this.state.country.find(
              (x) => x.displayvalue == list.countryid,
            );
            this.setState({
              addressTypeName,
              fields,
              selectedCountry,
              selectedTimeZone,
              reqFields,
              list,
              reqList,
              ipList,
              selectedAddressType,
              // isClicked: true,
            });
            if (list.countryid) {
              this.getState();
              setTimeout(
                () =>
                  this.setState({
                    selectedState: this.state.stateprovince.find(
                      (x) => x.displayvalue == list.stateid,
                    ),
                  }),
                300,
              );
            }
            if (list.stateid) {
              this.getCity();
              setTimeout(
                () =>
                  this.setState({
                    selectedCity: this.state.cityzone.find(
                      (x) => x.displayvalue == list.cityid,
                    ),
                  }),
                300,
              );
            }
          }
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    } else {
      // this.OnPlus();
    }
  }

  handleClickWithAction = (office) => {
    console.log(office);
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          color="inherit"
          size="small"
          onClick={() => this.DeleteLocation(office)}
        >
          Delete
        </Button>,
        <Button
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          Dismiss
        </Button>,
      ],
      // onClickAction: () => this.DeleteLocation(office)
    });
  };

  DeleteLocation() {
    const { selectedRow } = this.state;

    const data = {
      subscriptionid: get(this.state, "subscriptionid", ""),
      officeaddressid: selectedRow.displayvalue,
      addressid: selectedRow.addressid,
    };
    const URL = `subscription/companylocation/${get(
      this.props,
      "SubscriptionInfo.SubscriptionData.subscriptionid",
      "",
    )}/${selectedRow.officeaddressid}/${selectedRow.addressid}`;
    instance
      .delete(URL)
      .then((result) => {
        // this.GetLocations()

        // const index = this.state.listdata.findIndex(
        //   (x) => x.displayvalue == selectedRow.officeaddressid,
        // );
        // this.state.listdata.splice(index, 1);
        this.setState(
          { listdata: this.state.listdata, createmenu: false },
          () => this.getAllCompanyLocations(),
        );
        this.props.enqueueSnackbar("Location deleted successfully.", {
          variant: "success",
        });
      })
      .catch((error) => {
        // this.setState({
        //     CommonError: error.message
        // })
        this.props.enqueueSnackbar(error.response.data.error.message, {
          variant: "error",
        });
      });
  }

  // onEdit() {
  //   const { selectedRow } = this.state;
  //   const URL = `subscription/companylocation/${get(
  //     this.state,
  //     "subscriptionid",
  //     "",
  //   )}/${selectedRow.officeaddressid}/${selectedRow.addressid}`;
  //   instance.get(URL).then((resp) => {
  //     this.setState(
  //       { postData: resp.data.result[0], createmenu: false },
  //       () => {
  //         this.props.history.push(`${this.props.match.url}/create`);
  //       },
  //     );
  //   });
  // }

  onEdit() {
    const { selectedRow } = this.state;

    const URL = `subscription/companylocation/${get(
      this.props,
      "SubscriptionInfo.SubscriptionData.subscriptionid",
      "",
    )}/${selectedRow.officeaddressid}/${selectedRow.addressid}`;
    instance
      .get(URL)
      .then((result) => {
        const data = result.data.result;
        if (data) {
          const fields = {
            accountid: data && data.accountid && data.accountid,
            subscriptionid: data && data.subscriptionid && data.subscriptionid,
            officeaddressid:
              data && data.officeaddressid && data.officeaddressid,
            addressid: data && data.addressid && data.addressid,
            locationname: data && data.locationname && data.locationname,
            addressline1: data && data.addressline1 && data.addressline1,
            addressline2: data && data.addressline2 && data.addressline2,
            pincode: data && data.pincode && data.pincode,
            longitude: data && data.longitude && data.longitude,
            latitude: data && data.latitude && data.latitude,
            radius: data && data.radius && data.radius,
          };
          const ipList =
            result.data.result.ip.length > 0
              ? result.data.result.ip
              : this.state.ipList;
          const reqFields = {
            locationname: data && data.locationname,
            addressline1: data && data.addressline1,
            pincode: data && data.pincode,
            // longitude: data && data.longitude,
            // latitude: data && data.latitude,
            // radius: data && data.radius
          };
          const list = {
            addresstype: data.addresstype,
            countryid: data.countryid,
            stateid: data.stateid,
            cityid: data.cityid,
            countrytimezoneid: data.countrytimezoneid,
          };
          const reqList = {
            addresstype: data.addresstype,
            countryid: data.countryid,
            stateid: data.stateid,
            cityid: data.cityid,
            countrytimezoneid: data.countrytimezoneid,
          };

          const selectedAddressType = this.state.addressTypeList.find(
            (x) => x.displayvalue == list.addresstype,
          );
          let addressTypeName = "";
          for (const type of this.state.addressTypeList) {
            if (type.displayvalue == list.addresstype) {
              addressTypeName = type.displayname;
            }
          }
          const selectedTimeZone = this.state.timezones.find(
            (x) => x.displayvalue == list.countrytimezoneid,
          );
          const selectedCountry = this.state.country.find(
            (x) => x.displayvalue == list.countryid,
          );
          this.setState(
            {
              addressTypeName,
              fields,
              selectedCountry,
              selectedTimeZone,
              reqFields,
              list,
              ipList,
              reqList,
              selectedAddressType,
              createmenu: false,
            },
            () => {
              this.props.history.push(`${this.props.match.url}/create`);
            },
          );
          if (list.countryid) {
            this.getState();
            setTimeout(
              () =>
                this.setState({
                  selectedState: this.state.stateprovince.find(
                    (x) => x.displayvalue == list.stateid,
                  ),
                }),
              300,
            );
          }
          if (list.stateid) {
            this.getCity();
            setTimeout(
              () =>
                this.setState({
                  selectedCity: this.state.cityzone.find(
                    (x) => x.displayvalue == list.cityid,
                  ),
                }),
              500,
            );
          }
        }
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  clearAll() {
    this.setState({
      value: 2,
      flag: 0,
      MarkdownText: "",
      progress: 0,
      subscriptionid:
        this.props.currentsubscription &&
        this.props.currentsubscription.subscriptionid,
      // officeaddressid: this.props.officedata.displayvalue,
      // addressid: this.props.officedata.addressid,
      checkedA: true,
      checkedB: true,
      selectedAddressType: {
        displayname: "Select Address Type",
        displayvalue: null,
      },
      fields: {
        locationname: "",
        addressline1: "",
        addressline2: "",
        pincode: "",
        officeaddressid: "",
        addressid: "",
        longitude: "",
        latitude: "",
        radius: "",
      },
      reqFields: {
        locationname: "",
        addressline1: "",
        pincode: "",
        // longitude: "",
        // latitude: "",
        // radius: ""
      },
      list: {
        addresstype: "",
        countryid: "",
        stateid: "",
        cityid: "",
        countrytimezoneid: "",
      },
      reqList: {
        addresstype: "",
        countryid: "",
        stateid: "",
        cityid: "",
        countrytimezoneid: "",
      },
      errors: {},
      selectedCountry: {
        displayvalue: null,
        displayname: "Select Country",
      },
      stateprovince: [],
      selectedState: {
        displayvalue: null,
        displayname: "Select State",
      },
      cityzone: [],
      selectedCity: {
        displayname: "Select City",
        displayvalue: null,
      },
      selectedNetworkType: {},
      selectedTimeZone: {
        displayname: "Select TimeZone",
        displayvalue: null,
      },
      ipList: [
        {
          ipaddressfrom: "",
          ipaddressto: "",
          isblocked: false,
          networktypeid: "",
          officeaddressid: undefined,
          officeaddressipid: 0,
        },
      ],
    });
  }

  onDelete(office) {
    console.log(this.state.selectedRow);
    const { selectedRow } = this.state;
    const URL = `subscription/companylocation/${get(
      this.state,
      "subscriptionid",
      "",
    )}/${office.displayvalue}/${office.addressid}`;
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            instance
              .delete(URL)
              .then((result) => {
                // this.GetLocations()

                const index = this.state.Location.findIndex(
                  (x) => x.displayvalue == office.displayvalue,
                );
                this.state.Location.splice(index, 1);
                this.setState({ Location: this.state.Location });
                this.props.enqueueSnackbar("Location deleted successfully.", {
                  variant: "success",
                });
              })
              .catch((error) => {
                // this.setState({
                //     CommonError: error.message
                // })
                this.props.enqueueSnackbar(error.response.data.error.message, {
                  variant: "error",
                });
              });
          }}
        >
          Yes
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          No
        </Button>,
      ],
    });
  }

  // onContinue() {
  //   if (this.props.dashboard == false) {
  //     this.OnFormSubmit();
  //     return;
  //   }

  //   if (this.state.Location.length > 1) {
  //     // if(this.state.isSave){
  //     this.OnFormSubmit();
  //     // this.props.updateStep(4);
  //     // } else{
  //     //   this.props.enqueueSnackbar(
  //     //   "Please fill at least one location"
  //     //   ,{variant:"error"});
  //     // }
  //   } else {
  //     this.props.enqueueSnackbar("Please fill at least one location", {
  //       variant: "error",
  //     });
  //   }
  // }

  _onCreate = () => {
    const { match } = this.props;
    this.props.history.push(`${match.path}/create`);
  };

  _renderForm = () => (
    <div>
      <p className="large-text-dark-secondary t-bold margin-bottom-32">
        Add new office location
      </p>
      <Grid container spacing={3}>
        <Grid item md={6} sm={12}>
          <div className="margin-bottom-24">
            <p className="input-label">Location Name</p>
            <TextField
              className="margin-top-0 width100 margin-bottom-0"
              style={{ background: "white" }}
              placeholder="Enter Name"
              // id="outlined-bare"
              type="text"
              margin="normal"
              variant="outlined"
              onFocus={this.SetHelperTextFlag.bind(
                this,
                "locationname",
                "Htlocationname",
              )}
              onChange={this.OnFieldChange.bind(this, "locationname", "name")}
              onBlur={this.ValidateField.bind(this, "locationname", "name")}
              value={this.state.fields.locationname}
              maxLength="50"
            />
            <div>
              {this.state.errors.locationname ? (
                <span className="caption-error">
                  <FormattedMessage
                    id="ErOfficeLocationName"
                    defaultMessage="can not be empty"
                  />
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="margin-bottom-24">
            <p className="input-label">Address Line 1</p>

            <TextArea
              className="margin-top-0 width100 margin-bottom-0"
              placeholder="Enter address line 1"
              // id="outlined-bare"
              variant="outlined"
              multiline
              margin="normal"
              onChange={this.OnFieldChange.bind(this, "addressline1", "name")}
              onBlur={this.ValidateField.bind(this, "addressline1", "name")}
              maxLength="100"
              value={this.state.fields.addressline1}
            />
            <div>
              {this.state.errors.addressline1 ? (
                <span className="caption-error">
                  <FormattedMessage
                    id="ErAddressLineOne"
                    defaultMessage="can not be empty"
                  />
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="margin-bottom-24">
            <p className="input-label">Select Country</p>

            <Select
              onChange={this.UpdateSelectedDropdownItem.bind(
                this,
                "countryid",
                "HtCountry",
              )}
              options={this.state.country}
              getOptionLabel={(option) => option.displayname}
              getOptionValue={(option) => option.displayvalue}
              value={this.state.selectedCountry}
            />
            <div>
              {this.state.errors.countryid ? (
                <span className="caption-error">
                  <FormattedMessage
                    id="ErCountry"
                    defaultMessage="Please select country"
                  />
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="margin-bottom-24">
            <p className="input-label">
              <label htmlFor="Currency">City/Zone</label>
            </p>
            <Select
              onChange={this.UpdateSelectedDropdownItem.bind(
                this,
                "cityid",
                "HtCity/Zone",
              )}
              options={this.state.cityzone}
              getOptionLabel={(option) => option.displayname}
              getOptionValue={(option) => option.displayvalue}
              value={this.state.selectedCity}
              placeholder="Select City"
            />
            <div>
              {this.state.errors.cityid ? (
                <span className="caption-error">
                  <FormattedMessage
                    id="ErCity/Zone"
                    defaultMessage="Please select city"
                  />{" "}
                </span>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="margin-bottom-24">
            <p className="input-label">Timezone</p>
            <Select
              className=""
              placeholder="Select Time Zone"
              onChange={this.UpdateSelectedDropdownItem.bind(
                this,
                "countrytimezoneid",
                "HtTimeZone",
              )}
              options={this.state.timezones}
              getOptionLabel={(option) => option.displayname}
              getOptionValue={(option) => option.displayvalue}
              value={this.state.selectedTimeZone}
            />
            <div>
              {this.state.errors.countrytimezoneid ? (
                <span className="caption-error">
                  <FormattedMessage
                    id="ErTimeZone"
                    defaultMessage="Please select country time zone"
                  />{" "}
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="margin-bottom-24">
            <p className="input-label">Geo location(Optional)</p>
            <TextField
              type="number"
              error={
                (this.state.fields.latitude || this.state.fields.longitude) &&
                !/^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$/.test(
                  get(this.state, "fields.latitude", ""),
                )
              }
              style={{ width: "100%", background: "white" }}
              // type="number"
              placeholder="Latitude"
              variant="outlined"
              onChange={this.OnFieldChange.bind(this, "latitude", "latitude")}
              value={this.state.fields.latitude}
            />
          </div>
          <div className="margin-bottom-24">
            {this.state.ipList &&
              this.state.ipList.map((item, i) => {
                const selectedNetweorkType = this.state.networkTypeList.find(
                  (x) => x.displayvalue == item.networktypeid,
                );
                return (
                  <div key="key" style={{ marginBottom: 110 }}>
                    <p className="input-label">
                      <FormattedMessage
                        id="LbIpAdreessoptional"
                        defaultMessage="IP Address (Optional)"
                      />
                    </p>
                    <Select
                      onChange={this.UpdateSelectedIpAddressType.bind(
                        this,
                        item,
                        "HtIpAdreess",
                      )}
                      options={this.state.networkTypeList}
                      getOptionLabel={(option) => option.displayname}
                      getOptionValue={(option) => option.displayvalue}
                      value={selectedNetweorkType || null}
                      placeholder="Select IP Address Type"
                    />
                    <div>
                      {item.networktypeid == "1" ? (
                        <form>
                          <Grid container style={{ marginTop: 15 }}>
                            <Grid item md={6}>
                              <TextField
                                error={
                                  (item.ipaddressfrom || item.ipaddressto) &&
                                  !REGEX_IP.test(get(item, "ipaddressfrom", ""))
                                }
                                className="mui-Textfield "
                                // type="number"
                                style={{
                                  width: "90%",
                                  background: "white",
                                }}
                                placeholder="From"
                                variant="outlined"
                                onChange={this.ipAddressUpdate.bind(
                                  this,
                                  item,
                                  i,
                                  "ipaddressfrom",
                                )}
                                value={item.ipaddressfrom}
                              />
                            </Grid>
                            <Grid item md={6}>
                              <TextField
                                error={
                                  (item.ipaddressfrom || item.ipaddressto) &&
                                  !REGEX_IP.test(get(item, "ipaddressto", ""))
                                }
                                style={{ background: "white" }}
                                className="mui-Textfield width100"
                                // type="number"
                                placeholder="To"
                                variant="outlined"
                                onChange={this.ipAddressUpdate.bind(
                                  this,
                                  item,
                                  i,
                                  "ipaddressto",
                                )}
                                value={item.ipaddressto}
                              />
                            </Grid>
                          </Grid>
                          <div style={{ clear: "both" }} />
                          <div>
                            {item.IPv4From ? (
                              <span className="caption-error">
                                <FormattedMessage
                                  id="ErIPv4From"
                                  defaultMessage="Please enter valid IP Address From for IPv4 "
                                />
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                          <div>
                            {item.IPv4To ? (
                              <span className="caption-error">
                                <FormattedMessage
                                  id="ErIPv4To"
                                  defaultMessage="Please enter valid IP Address To for IPv4 "
                                />{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </form>
                      ) : (
                        ""
                      )}
                      {item.networktypeid == "2" ? (
                        <form>
                          <div className="floatleft margin-right-16">
                            <input
                              type="text"
                              style={{ background: "white" }}
                              className="form-control ipAddressInput"
                              id="IPv6From"
                              placeholder="From"
                              onFocus={this.SetHelperTextFlag.bind(
                                this,
                                "IPv6From",
                                "HtIpAdreess",
                              )}
                              onChange={this.ipAddressUpdate.bind(
                                this,
                                item,
                                i,
                                "ipaddressfrom",
                              )}
                              // onBlur={this.ValidateIP6.bind(
                              //   this,
                              //   item,
                              //   i,
                              //   "IPv6From",
                              //   "ipaddressfrom"
                              // )}
                              value={item.ipaddressfrom}
                            />
                          </div>
                          <div className="floatleft">
                            <input
                              type="text"
                              style={{ background: "white" }}
                              className="form-control ipAddressInput"
                              id="IPv6To"
                              placeholder="To"
                              onFocus={this.SetHelperTextFlag.bind(
                                this,
                                "IPv6To",
                                "HtIpAdreess",
                              )}
                              // onChange={this.OnFieldChange.bind(this, "To", "text")}
                              onChange={this.ipAddressUpdate.bind(
                                this,
                                item,
                                i,
                                "ipaddressto",
                              )}
                              // onBlur={this.ValidateIP6.bind(
                              //   this,
                              //   item,
                              //   i,
                              //   "IPv6To",
                              //   "ipaddressto"
                              // )}
                              value={item.ipaddressto}
                            />
                            {/*
                                <Checkbox
                                  checked={item.isblocked}
                                  onChange={e => this.handleChange(e, item, i)}
                                  value={item.isblocked}
                                  color="primary"
                                  style={{height:14, marginTop:-14}}
                                />
                                isblocked */}
                          </div>
                          <div style={{ clear: "both" }} />
                          <div>
                            {item.IPv6From ? (
                              <span className="caption-error">
                                <FormattedMessage
                                  id="ErIPv6From"
                                  defaultMessage="Please enter valid IP Address From for IPv6 "
                                />{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                          <div>
                            {item.IPv6To ? (
                              <span className="caption-error">
                                <FormattedMessage
                                  id="ErIPv6To"
                                  defaultMessage="Please enter valid IP Address To for IPv6 "
                                />{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </form>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                );
              }, this)}
          </div>
        </Grid>
        <Grid item md={6} sm={12}>
          <div className="margin-bottom-24">
            <p className="input-label">Address type</p>
            <Select
              onChange={this.UpdateSelectedDropdownItem.bind(
                this,
                "addresstype",
                "HtAddressType",
              )}
              placeholder="Select Address Type"
              options={this.state.addressTypeList}
              getOptionLabel={(option) => option.displayname}
              getOptionValue={(option) => option.displayvalue}
              value={this.state.selectedAddressType}
            />
            <div>
              {this.state.errors.addresstype ? (
                <span className="caption-error">
                  <FormattedMessage
                    id="ErAddressType"
                    defaultMessage="Please select address type"
                  />
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="margin-bottom-24">
            <p className="input-label">Address Line 2 (Optional)</p>
            <TextArea
              className="margin-top-0 width100 margin-bottom-0"
              placeholder="Enter address line 2"
              id="outlined-bare"
              variant="outlined"
              multiline
              margin="normal"
              onChange={this.OnFieldChange.bind(this, "addressline2", "name")}
              maxLength="100"
              value={this.state.fields.addressline2}
            />
          </div>
          <div className="margin-bottom-24">
            <p className="input-label">
              <label htmlFor="Currency">State/Province</label>
            </p>
            <Select
              onChange={this.UpdateSelectedDropdownItem.bind(
                this,
                "stateid",
                "HtState/Province",
              )}
              placeholder="Select State"
              options={this.state.stateprovince}
              getOptionLabel={(option) => option.displayname}
              getOptionValue={(option) => option.displayvalue}
              value={this.state.selectedState}
            />
            <div>
              {this.state.errors.stateid ? (
                <span className="caption-error">
                  <FormattedMessage
                    id="ErState/Province"
                    defaultMessage="Please select state"
                  />
                </span>
              ) : (
                ""
              )}
            </div>
          </div>

          <div className="margin-bottom-24">
            <p className="input-label">Enter postal code</p>
            <div>
              <TextField
                id="outlined-bare"
                margin="normal"
                variant="outlined"
                style={{
                  marginTop: 0,
                  width: "100%",
                  background: "white",
                  marginBottom: 0,
                }}
                placeholder="pincode/zipcode"
                onFocus={this.SetHelperTextFlag.bind(
                  this,
                  "pincode",
                  "HtPostalCode",
                )}
                onChange={this.OnFieldChange.bind(this, "pincode", "text")}
                onBlur={this.ValidateField.bind(this, "pincode", "text")}
                value={this.state.fields.pincode}
                maxLength="10"
              />
            </div>
            <div>
              {this.state.errors.pincode ? (
                <span className="caption-error">
                  <FormattedMessage
                    id="ErPostalCode"
                    defaultMessage="Please enter postal code"
                  />
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="margin-bottom-24">
            <p className="input-label">Geo Radius(Optional)</p>
            <TextField
              error={this.state.fields.radius && this.state.fields.radius < 30}
              type="number"
              id="radius"
              style={{ width: "100%", background: "white" }}
              placeholder="Geo Radius"
              variant="outlined"
              onChange={this.OnFieldChange.bind(
                this,
                "radius",
                "geo-radius-new",
              )}
              value={this.state.fields.radius}
            />
          </div>
          <div className="margin-bottom-24">
            <p className="input-label">Longitude</p>
            <TextField
              type="number"
              error={
                (this.state.fields.latitude || this.state.fields.longitude) &&
                !/^(\+|-)?(?:180(?:(?:\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,6})?))$/.test(
                  get(this.state, "fields.longitude", ""),
                )
              }
              style={{ width: "100%", background: "white" }}
              // type="number"
              variant="outlined"
              placeholder="Longitude"
              onChange={this.OnFieldChange.bind(this, "longitude", "longitude")}
              value={this.state.fields.longitude}
            />
          </div>
        </Grid>
      </Grid>
      <div
        className="width100"
        style={{
          position: "fixed",
          left: 0,
          background: "white",
          bottom: 0,
          padding: 10,
          borderTop: "1px solid #d4d4d4",
          zIndex: 0,
        }}
      >
        <div className="floatleft" style={{ marginLeft: 304 }}>
          <Button
            className="btn btn-secondary-md-blue margin-right-16"
            variant="contained"
            onClick={this.onCancel}
          >
            Cancel
          </Button>
        </div>
        <div className="floatright" style={{ marginRight: 72 }}>
          <div>
            <Button
              variant="contained"
              color="primary"
              size="large"
              className="btn btn-primary-md-blue"
              onClick={this.OnFormSubmit.bind(this)}
            >
              Save
            </Button>
          </div>
        </div>
        <div className="clearfloat"></div>
      </div>
    </div>
  );

  _renderList = () => {
    const { departmentList } = this.props;

    return (
      <div>
        <div
          className="display-flex"
          style={{ justifyContent: "space-between" }}
        >
          <p className="large-text-dark-secondary t-bold margin-bottom-32">
            Company offices
          </p>
          <Button
            variant="contained"
            color="primary"
            size="large"
            className="btn btn-primary-md-blue"
            // onClick={this.OnFormSubmit.bind(this)}
            onClick={this._onCreate}
          >
            Add office
          </Button>
        </div>
        <List
          showOnlyList={true}
          list={this.state.listdata}
          headers={this.state.headers}
          onCreate={this._onCreate}
          onEdit={this.onEdit}
          onDelete={this.DeleteLocation}
          module=""
          goTo={this.props.goTo}
          permissions={this.state.permissions}
          onMoreOptionClick={(e, row) => this.onMoreOptionClick(e, row)}
        />
        <Popover
          open={this.state.createmenu}
          anchorEl={this.state.create_anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          onClose={() => this.setState({ createmenu: false })}
          className="margin-top-8"
        >
          <Paper style={{ width: 190 }}>
            <div>
              <MenuListComponent>
                <ListItem
                  className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                  onClick={this.onEdit}
                >
                  <ListItemText style={{ padding: 0 }}>
                    <span className="small-dark-secondary">Edit</span>
                  </ListItemText>
                </ListItem>
                <ListItem
                  className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                  onClick={this.DeleteLocation}

                  // onClick={this.DeleteLocation(office)}
                >
                  <ListItemText style={{ padding: 0 }}>
                    <span className="small-dark-secondary">Delete</span>
                  </ListItemText>
                </ListItem>
              </MenuListComponent>
            </div>
          </Paper>
        </Popover>
      </div>
    );
  };

  _renderComponent = () => {
    const { listdata } = this.state;
    if (listdata.IsPending) {
      return this.showLoader();
    }

    return (
      <div>
        {/* {Location && Location.length == 0 && this._renderCreate()} */}
        {listdata && listdata.length > 0 && this._renderList()}
      </div>
    );
  };

  // _renderCreate = () => (
  //   <CreateComp
  //     text={this.getText()}
  //     heading={
  //       <FormattedMessage
  //         id="LbGradeConcept"
  //         defaultMessage="Concept of Grade"
  //       />
  //     }
  //     onCreate={this._onCreate}
  //     imageSrc={gradeConcept}
  //     permissions={this.state.permissions}
  //   />
  // );

  render() {
    const { match } = this.props;
    return (
      <div className="content-outer-wrapper">
        <div>
          <Switch>
            <Route
              exact
              path={`${match.path}/create`}
              render={this._renderForm}
            />

            <Route
              exact
              path={`${match.path}/list`}
              render={this._renderComponent}
            />
            <Route
              exact
              path={`${match.path}/`}
              render={this._renderComponent}
            />
          </Switch>
        </div>
        <Grid xs={12} md={12} sm={12}>
          <Grid container spacing={3}>
            {/* <Grid item md={4} sm={12} style={{ height: "100%" }}>
                  <Grid container style={{ marginTop: 4, height: "100%" }}>
                    <Grid item md={12} sm={12} style={{ height: "100%" }}>
                      {this.state.Location.lenght > 0 ? (
                        <span className="location-side-span">
                          <Add className="Add-icon"></Add>
                          <span className="addnew-icon-span">
                            Add New Address
                          </span>
                        </span>
                      ) : (
                        <div
                          style={{
                            height: "100%",
                            overflowY: "auto",
                            marginRight: 20,
                          }}
                          className="thin-scroll"
                        >
                          {this.state.Location.slice(1).map((item) => (
                            <span key="key" className="display-block">
                              <span
                                className={
                                  item.addressid == this.state.fields.addressid
                                    ? "location-side-span-active position-rel"
                                    : "location-side-span position-rel"
                                }
                                onClick={() => this.GetForm(item)}
                              >
                                {this.props.dashboard && (
                                  <div className="icon-float-right">
                                    <img
                                      src={DeleteIcon}
                                      align="center"
                                      height="24"
                                      width="24"
                                      onClick={() =>
                                        this.handleClickWithAction(item)
                                      }
                                      alt="delete"
                                    ></img>
                                  </div>
                                )}
                                <span
                                  style={{
                                    display: "block",
                                    marginTop: 20,
                                    width: "85%",
                                  }}
                                  className="ellipsis"
                                >
                                  {item.displayname}
                                </span>
                                <ArrowSide
                                  style={{
                                    height: 16,
                                    width: 16,
                                    position: "absolute",
                                    top: 24,
                                    right: 4,
                                    color:
                                      item.addressid ==
                                      this.state.fields.addressid
                                        ? "#1e8ced"
                                        : "#d9dadb",
                                  }}
                                />
                              </span>
                            </span>
                          ))}

                          <span
                            className="location-side-span-active position-rel"
                            onClick={this.clearAll}
                          >
                            <Add className="Add-icon"></Add>
                            <span className="t-14">Add new address</span>
                            <ArrowSide
                              style={{
                                height: 16,
                                width: 16,
                                position: "absolute",
                                top: 24,
                                right: 4,
                                color: "#1e8ced",
                              }}
                            />
                          </span>
                        </div>
                      )}
                    </Grid>
                  </Grid>
                </Grid> */}
          </Grid>
        </Grid>
      </div>
    );
  }
}

// company_location.propTypes = {
//   classes: PropTypes.object.isRequired,
//   theme: PropTypes.object.isRequired
// };

const mapStateToProps = (state) => ({
  AuthenticationAction: state.AuthenticationAction,
  SubscriptionInfo: state.SubscriptionInfo,
  selectionReducer: state.selectionReducer,
  onboarding: state.Onboarding,
});

export default withRouter(
  connect(mapStateToProps, null)(withSnackbar(company_location)),
);
